<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="d-flex justify-content-between">            
            <CButtonGroup>
              <div class="d-flex flex-wrap">
                <CButton
                  @click="mtdBack"
                  class="m-2 text-white"
                  style="background: #E46666"
                >
                  <i class="fas fa-hand-point-left"></i> Retroceder
                </CButton>
                <CButton                  
                  class="m-2"
                  v-for="role in roles"
                  :key="role.role.id"
                  @click="activateRole(role.role.id, role.role.name)"
                  :color="mtdGetClass(role.role.name)"
                >
                  {{ role.role.name }}</CButton
                >
              </div>
            </CButtonGroup>
          </div>
        </CCardHeader>
        <CCardBody style="background-color: #eeeeef;">
          <div v-if="activeRoleId">
            <PersonalVue
              class="pt-3"
              :roleId="activeRoleId"
              :roleName="activeRoleName"
              @mtdBack="mtdBack"
              @changeTab="changeTab"
            />
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapActions } from "vuex";
import PersonalVue from "./components/crudPersonal.vue";

export default {
  name: "c-maintenanca-personal",
  components: { PersonalVue},

  data() {
    return {
      activeRoleId: null,
      activeRoleName: '',
      roles: [],
    };
  },
  created() {
    this.get_companyRole();
  },
  watch:{
    
  },
  methods: {
    ...mapActions(["get", "post"]),
    get_companyRole() {
      this.get({
        url: this.$store.getters.get__url + "/companyRole",
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.roles = response.data;
        if (this.roles.length > 0) {
          this.activateRole(this.roles[0].role.id, this.roles[0].role.name);
        }
      });
    },
    activateRole(roleId, roleName) {
      this.activeRoleId = roleId;
      this.activeRoleName = roleName;
    },
    mtdBack() {
      this.$emit("mtdBack");
    },
    changeTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    mtdGetClass: function(name){
      return name == this.activeRoleName?'info':'default';
    }
  },
};
</script>

<style lang="scss" scoped></style>
